import { store } from 'index';

export const make_all_content_arr = (
    variant: 'content' | 'teacherContet',  
    array:   { [key: string]: any }[]
) => {

    const state = store.getState();
    let { bigContentArr, bigTeacherArr } = state.content;
    const arr = variant === 'content' ? array.concat(bigTeacherArr) : bigContentArr.concat(array);
    return arr
          
}
